import { render, staticRenderFns } from "./AddAffidavitForm.vue?vue&type=template&id=3bea2d7b&scoped=true"
import script from "./AddAffidavitForm.vue?vue&type=script&lang=ts"
export * from "./AddAffidavitForm.vue?vue&type=script&lang=ts"
import style0 from "./AddAffidavitForm.vue?vue&type=style&index=0&id=3bea2d7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bea2d7b",
  null
  
)

export default component.exports